import { SelectOption } from '@blueshift-ui/inputs';

export const GRADES: ReadonlyMap<number, string> = new Map([
  [1, 'Pre-Kindergarten'],
  [2, 'Kindergarten'],
  [3, '1st grade'],
  [4, '2nd grade'],
  [5, '3rd grade'],
  [6, '4th grade'],
  [7, '5th grade'],
  [8, '6th grade'],
  [9, '7th grade'],
  [10, '8th grade'],
  [11, '9th grade'],
  [12, '10th grade'],
  [13, '11th grade'],
  [14, '12th grade'],
  [15, 'College Freshman'],
  [16, 'College Sophomore'],
  [17, 'College Junior'],
  [18, 'College Senior'],
  [19, 'Graduate Student'],
  [20, 'Adult Learner'],
  [21, 'GRADE NOT SET'],
]);

export const GRADE_OPTIONS: SelectOption[] = Array.from(GRADES).map(([value, label]) => ({
  label,
  value: value.toString(),
}));
